import axios from "axios";

import { Fauth } from "../config/firebaseApp";

export const clientApi = axios.create({
  baseURL:
    process.env.REACT_APP_STATE === "test" ? "" : process.env.REACT_APP_BASEURL,
});

clientApi.interceptors.request.use(async (config) => {
  const idToken = await Fauth.currentUser?.getIdToken();
  if (idToken) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${idToken}`;
  }

  return config;
});

export const NetworkError = {
  state: false,
  data: undefined,
  msg: "네트워크 연결을 확인해주세요",
};
